(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('contactCaller', [ContactCallerDirectiveFn]);

    /* contact-caller directive */
    function ContactCallerDirectiveFn() {
        var directive = {
            //link: link,
            restrict: 'E',
            replace: false,
            templateUrl: '/app/ringfoon/templates/contact-caller.template.html',
            scope: {
                caller: '='
            }
        };
        return directive;

        //function link(scope) {

        //    activate();

        //    // activate directive
        //    function activate() {
        //    } // activate

        //    //// select current caller
        //    //function select() {
        //    //    CallsService.deselectCaller();
        //    //    scope.caller.selected = true;
        //    //    CallsService.call.caller = scope.caller;
        //    //}

        //    //// select current caller
        //    //scope.select = select;


        //} // link
    }
})();